import { Const } from '../lib/const.cls'

export const getters = {
	[Const.GET_COMMISSION_LIST]: (state) => { return state.getcommissionlist },
	[Const.GET_MARKET_HOLIDAYS]: (state) => { return state.market_holidays },
	[Const.GET_CLIENT_DATA]: (state) => { return state.getClientData },
	[Const.GET_COUNTRIES_LIST]: (state) => { return state.countriesList },
	[Const.GET_CITIES_LIST]: (state) => { return state.citiesList },

	[Const.GET_CLIENT_REPORT_LINK]: (state) => { return state.clientReportLink },

	[Const.GET_VPS_LIST]: (state) => { return state.vpsList },
	[Const.GET_SUBSCRIPTION_LIST]: (state) => { return state.subscriptionList },
	[Const.GET_SUBSCRIPTION_DETAIL]: (state) => { return state.subscriptionDetail },
	[Const.GET_USER_OTHER_DETAILS]: (state) => { return state.userOtherDetail },
	[Const.GET_LOYALITY_TRANSACTION_LIST]: (state) => { return state.transactionList },
	[Const.GET_LOYALITY_CARD_LIST]: (state) => { return state.cardList },
	
	
	//email
	[Const.GET_EMAIL_SETTING_LIST]: (state) => {	return state.emailList },

	//ib
	[Const.GET_IB_LIST]: (state) => {	return state.iblist },
	[Const.GET_IB_VIEW]: (state) => {	return state.ibView },

	[Const.GET_IB_CHANGE_LIST]: (state) => {	return state.ibchangelist },
	
	//subib
	[Const.GET_SUB_IB_LIST]: (state) => {	return state.subiblist },
	
	//permission
	[Const.GET_PERMISSION_LIST]: (state) => {	return state.permission },
	[Const.GET_EMAIL_DATA]: (state) => {	return state.emailData },
	
	//coupon
	[Const.GET_COUPON_LIST]: (state) => {	return state.couponList },
	
	
	
	
	//admin
	[Const.GET_GROUP_ADMIN_NAME]: (state) => {	return state.groupAdminName },
	[Const.GET_USER_GROUP_ID]: (state) => {	return state.userGroupId },
	[Const.GET_ADMIN_LIST]: (state) => {	return state.adminList },
	[Const.GET_ADMIN_DETAIL]: (state) => {	return state.adminDetail },

	[Const.GET_ALL_NOTIFICATION_LIST]: (state) => {	return state.notificationList },
	// [Const.GET_ADMIN_DETAIL]: (state) => {	return state.adminDetail },

	[Const.GET_NOTIFICATION_OLD_LIST]: (state) => {	return state.notificationListOld },
	[Const.GET_UNREAD_NOTIFICATION_LIST]: (state) => {	return state.notificationListUnread },
	
	//client
	[Const.GET_ARTICLE_LIST]: (state) => {	return state.articleList },
	[Const.GET_CAT_LIST]: (state) => {	return state.catList },
	[Const.GET_WITHDRAWAL_METHODS]: (state) => {	return state.withdrawalMethods },
	[Const.GET_WITHDRAWAL_METHOD_RESPONSE]: (state) => {	return state.withdrawalMethodResponse },
	
	[Const.GET_USER_LIST]: (state) => {	return state.userList },
	[Const.GET_LOGS_LIST]: (state) => {	return state.logsList },
	[Const.GET_LOGS_VIEW]: (state) => {	return state.logsView },
	[Const.GET_USER_VIEW]: (state) => {	return state.userView },
	[Const.GET_USER_COUNT]: (state) => {	return state.userCount },
	
	[Const.GET_GENDER_LIST]: (state) => {	return state.genderList },
	[Const.GET_INTERNAL_NOTES]: (state) => {	return state.internalNotes },
	[Const.GET_RISK_METRIX]: (state) => {	return state.riskMetrix },
	
	
	[Const.GET_DEPT_METHD]: (state) => {	return state.deptMethdList },

	[Const.GET_STEP]: (state) => {	return state.stepList },
	[Const.GET_TIMEZONE]: (state) => {	return state.timeZone },
	
	//ticket
	[Const.GET_TICKET_LIST]: (state) => {	return state.ticketList },
	[Const.GET_TICKET_VIEW]: (state) => {	return state.ticketView },
	[Const.GET_TICKET_REASON_LIST]: (state) => {	return state.ticketReasonList },
	[Const.GET_TICKET_REASON_LIST1]: (state) => {	return state.ticketReasonList1 },
	[Const.GET_TICKET_DOCS]: (state) => {	return state.ticketDocs },

	//Internal Ticket
	[Const.GET_INTERNAL_TICKET_REASON]: (state) => {	return state.internalReasonList },
	
	[Const.GET_TICKET_DATA]: (state) => {	return state.ticketData },

	[Const.GET_TICKET_DOCS_LINK]: (state) => {	return state.ticketDocsLink },
	[Const.GET_ZIP_DOCS_LINK]: (state) => {	return state.downloadUserZip},
	
	[Const.GET_DEPARMENT_LIST]: (state) => {	return state.department_list },
	[Const.GET_LANGUAGE_LIST]: (state) => {	return state.language_list },
	[Const.GET_TICKET_STATUS]: (state) => {	return state.ticketStatus },
	[Const.GET_TICKET_REASON]: (state) => {	return state.ticketReason },
	[Const.GET_TICKET_REPLY_PRE]: (state) => {	return state.ticket_reply_pre },

	//deposit
	[Const.GET_DEPOSIT_LIST]: (state) => {	return state.depositList },
	[Const.GET_DEPOSIT_VIEW]: (state) => {	return state.depositView },

	[Const.GET_DEPOSIT_STATUS]: (state) => {	return state.depositStatus },
	[Const.GET_DEPOSIT_METHOD]: (state) => {	return state.depositMethod },
	[Const.GET_BANK_OPTIONS]: (state) => {	return state.bankOpions },
	
	//bonus
	[Const.GET_BONUS_LIST]: (state) => {	return state.bonusList },
	[Const.GET_BONUS_VIEW]: (state) => {	return state.bonusView },
	
	//withdrawal
	[Const.GET_WITHD_STATUS]: (state) => {	return state.withStatus },
	[Const.GET_WITHDRAWAL_LIST]: (state) => { return state.withdrawalList },
	[Const.GET_WITHDRAWAL_LIST_MAKER]: (state) => { return state.withdrawalListMaker },
	[Const.GET_WITHDRAWAL_VIEW]: (state) => { return state.withdrawalView },

	[Const.GET_WITHDRAWAL_TYPE]: (state) => { return state.withdrawalType },
	[Const.GET_WITHDRAWAL_METHOD]: (state) => { return state.withdrawalMethod },
	[Const.GET_WITHDRAWAL_STATUS]: (state) => { return state.withdrawalStatus },
	[Const.GET_WITHDRAWAL_DOC_LINK]: (state) => { return state.withdrawalDocsLink },
	//trading
	[Const.GET_TRADING_LIST]: (state) => {	return state.tradingList },
	[Const.GET_TRADING_VIEW]: (state) => {	return state.tradingView },
	
	[Const.GET_CURRENCY]: (state) => { return state.currency },
	[Const.GET_DEMO_LIVE]: (state) => {	return state.demoLive },

	//bonus
	[Const.GET_BONUS_TYPE]: (state) => {	return state.bonusType },
	[Const.GET_BONUS_STATUS]: (state) => {	return state.bonusStatus },

	//tutorials

	[Const.GET_TUTORIAL_LIST]: (state) => {	return state.tutorialList },
	[Const.GET_TUT_COURSE]: (state) => {	return state.tutorialCourse },
	[Const.GET_TUT_CAT]: (state) => {	return state.tutorialCat },

	//tradingeducation

	[Const.GET_CATEGORY_LIST]: (state) => {	return state.categoryList },
	[Const.GET_POST_LIST]: (state) => {	return state.postList },


	[Const.GET_IB_USER_DOCUMENT_LINK]: (state) => {	return state.IbUserDocsLink },
	[Const.GET_IB_TICKET_DOCUMENT_LINK]: (state) => {	return state.IbticketDocsLink },

	[Const.GET_COMMISSION_REPORT_LIST]: (state) => { return state.commissionReportList },
	[Const.GET_COMMISSION_WITHDRAWAL_LIST]: (state) => { return state.commissionWithdrawalList },
	[Const.GET_COMMISSION_REPORT_DETAIL]: (state) => { return state.commissionReportDetail },
	[Const.GET_UPLOADS_LIST]: (state) => { return state.uploadsList },
	[Const.GET_CLIENT_LEADS]: (state) => { return state.clientLeads },


	[Const.GET_ADMIN_DEPOSIT_METHODS]: (state) => { return state.depositMethods },
	[Const.GET_LOYALITY_POINT_COUNT]: (state) => { return state.loyalityCount },
	
}



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/getters.js